export default "/images/DeepIntent.jpg?e68cb960aaba0e3faa6e39a52514c0db";